import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _styled from "@emotion/styled/base";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import SegmentLogo from '@segment/matcha/components/SegmentLogo';
import Button from '@segment/matcha/components/Button';
import ButtonText from '@segment/matcha/components/ButtonText';
import DesktopNavBase, * as DesktopNav from '@segment/matcha/recipes/Navigation2/DesktopNavigation';
import * as Navbar from '@segment/matcha/recipes/Navigation2/DesktopNavigation/Navbar';
import useNavigation from '@segment/matcha/recipes/Navigation2/useNavigation';
import { usePageConfig } from '@segment/contexts/page';
import utilityData from '../data/utility';
import Products from './Dropdowns/Products';
import Docs from './Dropdowns/Docs';
import Resources from './Dropdowns/Resources';
import Solutions from './Dropdowns/Solutions';
import SupportMenu from './SupportMenu';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";

var DesktopNavigation = function DesktopNavigation(_ref) {
  var announcement = _ref.announcement;
  var pageConfig = usePageConfig();

  var _useNavigation = useNavigation(),
      getDropdownLinkProps = _useNavigation.getDropdownLinkProps;

  var _utilityData = utilityData(pageConfig),
      demoButton = _utilityData.demoButton,
      loginButton = _utilityData.loginButton,
      links = _utilityData.links,
      signUpButton = _utilityData.signUpButton;

  return _jsxs(DesktopNavBase, {
    children: [_jsxs(DesktopNav.UtilityNav, {
      announcement: announcement,
      children: [links.map(function (el) {
        return _jsx(SupportMenu, {
          links: el
        }, el.title);
      }), _jsx(ButtonTextSmall, {
        size: "small",
        variant: "mono",
        href: loginButton.url,
        children: loginButton.text
      })]
    }), _jsxs(DesktopNav.Navbar, {
      children: [_jsx(Navbar.Brand, {
        href: "/",
        children: _jsx(SegmentLogo, {
          alt: "Twilio, Inc."
        })
      }), _jsxs(Navbar.Content, {
        children: [_jsx("li", {
          children: _jsx(Navbar.Link, _objectSpread(_objectSpread({
            title: "Products"
          }, getDropdownLinkProps("products")), {}, {
            children: _jsx(Products, {})
          }))
        }), _jsx("li", {
          children: _jsx(Navbar.Link, _objectSpread(_objectSpread({
            title: "Solutions"
          }, getDropdownLinkProps("solutions")), {}, {
            children: _jsx(Solutions, {})
          }))
        }), _jsx("li", {
          children: _jsx(Navbar.Link, {
            title: "Pricing",
            href: "/pricing/"
          })
        }), _jsx("li", {
          children: _jsx(Navbar.Link, _objectSpread(_objectSpread({
            title: "Docs"
          }, getDropdownLinkProps("docs")), {}, {
            children: _jsx(Docs, {})
          }))
        }), _jsx("li", {
          children: _jsx(Navbar.Link, _objectSpread(_objectSpread({
            title: "Resources"
          }, getDropdownLinkProps("resources")), {}, {
            children: _jsx(Resources, {})
          }))
        })]
      }), _jsxs(Navbar.Aside, {
        children: [_jsx(ButtonText, {
          href: signUpButton.url,
          size: "small",
          variant: "mono",
          children: signUpButton.text
        }), _jsx(Button, {
          size: "medium",
          color: "primary",
          variant: "filled",
          href: demoButton.url,
          children: demoButton.text
        })]
      })]
    })]
  });
};

export default DesktopNavigation;

var ButtonTextSmall = /*#__PURE__*/_styled(ButtonText, true ? {
  target: "ejfifju0"
} : {
  target: "ejfifju0",
  label: "ButtonTextSmall"
})("font-size:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.buttonSmall;
}, ";" + (true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));